import { Component, OnInit, inject } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ConversationalAnalyticsSettingsComponent } from './conversational-analytics-settings/conversational-analytics-settings.component';
import { VirtualAgentSettingsComponent } from './virtual-agent-settings/virtual-agent-settings.component';
import { CallRecordingSettingsComponent } from './call-recording-settings/call-recording-settings.component';
import { AnsweringMachineDetectionSettingsComponent } from './answering-machine-detection-settings/answering-machine-detection-settings.component';
import { CommonModule } from '@angular/common';
import { LocalizationPipe } from '@abp/ng.core';
import { DashboardService } from 'src/app/features/dashboard/services/dashboard.service';
import { InfoBannerComponent } from 'src/app/shared/components/info-banner/info-banner.component';
import { ImportSource } from '../data-import/models/import-source.model';

@Component({
  selector: 'app-integration-settings',
  imports: [
    NgbNavModule,
    CommonModule,
    ConversationalAnalyticsSettingsComponent,
    VirtualAgentSettingsComponent,
    CallRecordingSettingsComponent,
    AnsweringMachineDetectionSettingsComponent,
    LocalizationPipe,
    InfoBannerComponent,
  ],
  templateUrl: './integration-settings.component.html',
  styleUrl: './integration-settings.component.scss',
})
export class IntegrationSettingsComponent implements OnInit {
  private readonly dashboardService = inject(DashboardService);

  activeTab = 1;
  isConversationalAnalyticsIntegrationActive = true;
  isVirtualAgentIntegrationActive = true;

  conversationalAnalyticsHasActiveSync = false;
  virtualAgentHasActiveSync = false;

  ngOnInit(): void {
    this.activeTab = 1;
    this.checkActiveSync();
  }

  get hasActiveSyncBanner(): boolean {
    if (this.activeTab === 1) {
      return this.conversationalAnalyticsHasActiveSync;
    }

    if (this.activeTab === 2) {
      return this.virtualAgentHasActiveSync;
    }

    return false;
  }

  private checkActiveSync(): void {
    this.dashboardService.hasActiveSync(ImportSource.CA).subscribe({
      next: hasActive => {
        this.conversationalAnalyticsHasActiveSync = hasActive;
      },
    });

    this.dashboardService.hasActiveSync(ImportSource.VA).subscribe({
      next: hasActive => {
        this.virtualAgentHasActiveSync = hasActive;
      },
    });
  }
}
